import { Contact, LienExterne, Partie } from './Morceaux';

/**
 * « Mentions légales » (chantier comptes, ticket 05). L'éditeur est un particulier, à titre non
 * professionnel : la LCEN (article 1-1, II, depuis la loi SREN de 2024) lui permet de ne donner
 * que le nom et l'adresse de l'hébergeur. Ceux d'Hostinger sont pris sur son site officiel ;
 * source et date dans `docs/rgpd.md`. Aucun nom ni adresse de l'éditeur n'est écrit ici.
 */
export function MentionsLegales() {
  return (
    <>
      <Partie titre="Éditeur">
        <p>
          Nextilt est un site personnel, édité par un particulier à titre non professionnel. Comme la loi le permet
          (article 1-1, II de la loi n°&nbsp;2004-575 du 21 juin 2004 pour la confiance dans l’économie
          numérique), son éditeur ne publie pas son identité, seulement celle de son hébergeur. Pour
          le joindre&nbsp;:
        </p>
        <Contact />
      </Partie>

      <Partie titre="Hébergeur">
        <p className="page-publique-adresse">
          Hostinger International Ltd
          <br />
          61 Lordou Vironos str.
          <br />
          6023 Larnaca, Chypre
          <br />
          <LienExterne href="https://www.hostinger.fr">hostinger.fr</LienExterne>
        </p>
        <p>Le serveur qui fait tourner Nextilt est situé en France.</p>
      </Partie>

      <Partie titre="Données personnelles">
        <p>
          Ce que Nextilt garde, pourquoi, combien de temps, et tes droits&nbsp;: la page{' '}
          <a href="/confidentialite">Confidentialité</a>.
        </p>
      </Partie>
    </>
  );
}
